import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {Link} from 'react-router-dom';


const Blog = () => {

    return(
       <div>
<Container fluid className="bordiContainerBlog">
    <Row>
        <Col id="ColHover" className="bordoColonna" md={2} >
          <div data-aos="fade-right">
          <Link to="/blog">
          <h1 className='vertical-rl'><small className='more'>More to</small> Blog</h1>
          </Link>
          </div>
        </Col>

       

        <Col className=' thumb'>
         
        <div data-aos="fade-left">
    <div>
        <div className="list-group justify-content-center">
        <Link to="/excel" className="list-group-item list-group-item-action hoverBlog">
    <div className=" d-flex1 w-100 justify-content-between">
      <h5 className="mb-1 sopra">Tenere Traccia delle spese con un File Excel</h5>
      <small className="text-muted1">Finanze</small>
    </div>
  </Link>
  <Link to="/lavoro" className="list-group-item list-group-item-action hoverBlog">
    <div className="d-flex1 w-100 justify-content-between">
      <h5 className="mb-1">I migliori siti per trovare lavoro</h5>
      <small className="text-muted1">Liste</small>
    </div>
  </Link>
  <Link to="/weblist" className="list-group-item list-group-item-action hoverBlog">
    <div className="d-flex1 w-100 justify-content-between ">
      <h5 className="mb-1">WebList</h5>
          <small className="text-muted1">Liste</small>
    </div>
  </Link>
</div>
</div>
</div>


       </Col>
   
      </Row>
      </Container>



      </div>

    );
}

export default Blog;